export const PostEditorValidationMessages = {
  expandAccordionTooltip: 'expand to see the error(s)',
  addToQueuePosition: {
    required: 'Please select a position.'
  },
  evergreen: {
    expireAfter: {
      required: 'Please pick a valid date.',
      checkExpiryDate: 'Expiry date should be later than post date.'
    },
    expireCounter: {
      required: 'Please select a value.',
      checkExpiryCount: 'Number of times to recycle should be greater than the total number of scheduled dates.'
    },
    expire: {
      required: 'Please select an expire option.'
    }
  },
  schedule: {
    scheduleTextOrMediaVariations:
      'Make sure to schedule enough cycles to cover all text/media variations of your post or simply turn Evergreen Recycling on. You may also adjust the content to reduce the number of variations',
    type: {
      required: 'Please select a schedule type.'
    },
    postOn: {
      date: {
        required: 'Please pick a valid date.'
      },
      hours: {
        required: 'Please select a hour.'
      },
      minutes: {
        required: 'Please select a minute.'
      },
      ampm: {
        required: 'Please select AM/PM.'
      }
    },
    recurringInterval: 'Only values between 1 and 500 are allowed.',
    timezone: {
      required: 'Please select a timezone.'
    }
  },
  linkSettingsModal: {
    required: 'Please provide a link value.',
    invalid: 'You need to provide a valid url.'
  },
  media: {
    varyMedia: {
      required: 'Please select a value.'
    }
  },
  categoryRequired: 'Select a Category.',
  checkDateAndTime: 'Set a future date and time.',
  checkDisconectedProfiles: 'Profile(s) require reconnection',
  checkLinksPresent: {
    gmb: 'The link needs to be present in order to be published. You may wish to add it to the text, completely remove it from your post, or use it for call-to-action button.',
    igtw: 'The link needs to be present in the post text in order to be published. You may wish to add it to the text or completely remove it from your post.',
    gmbigtw:
      'The link needs to be present in the post text in order to be published. You may wish to add it to the text or completely remove it from your post. For Google Business you can also use it for the call-to-action button.'
  },
  checkLinkPreviewSuppressed:
    'The link needs to be present in order to be published. You may wish add it to the Post Text, use link preview instead or completely remove the link from your post.',
  checkQueuePosition: 'Select Queue position, either Top or Bottom.',
  facebookContentRequired: 'Facebook posts cannot be empty. Add text, media, or a link preview to your Post.',
  facebookTextCharLimit: 'Facebook posts cannot be longer than 63,206 characters',
  facebookMediaLimit: 'Facebook posts cannot contain more than 10 images or 1 video/GIF',
  facebookTwitterLineBreakLimit: {
    fb: 'Facebook only allows single empty lines.',
    tw: 'X (Twitter) only allows single empty lines.',
    fbtw: 'Facebook and X (Twitter) only allow single empty lines.'
  },
  googleTextCharLimit: 'Google Business Profile post cannot be longer than 1500 characters',
  googleMediaLimit: 'Google Business Profile post cannot contain more than 1 images',
  googleMinMedia:
    'Google Business Profile post cannot have attached images smaller than 250px X 250px in resolution and less than 10 Kb in size.',
  instagramFacebookFirstCommentCharLimit: {
    fb: 'Facebook First Comment cannot be longer than 2200 characters',
    ig: 'Instagram First Comment cannot be longer than 2200 characters',
    fbig: 'Facebook and Instagram First Comment cannot be longer than 2200 characters'
  },
  instagramHashtagLimit:
    'Instagram does not allow adding the total of over 30 hashtags across Post Text (each variation) and First Comment.',
  instagramMediaLimit: 'Instagram post cannot contain more than 10 images or 1 video',
  instagramTextCharLimit: 'Instagram post cannot be longer than 2200 characters',
  linkedinTextChartLimit: 'LinkedIn post cannot be longer than 3000 characters',
  linkedinFirstCommentCharLimit: 'LinkedIn First Comment cannot be longer than 2000 characters',
  linkedinMediaLimit: 'LinkedIn post cannot contain more than 20 images or 1 video/GIF',
  mediaRequired: {
    ig: "Instagram requires at least 1 image/video to be added. If your post contains a link, we'll attempt to retrieve its preview image to use as the media.",
    pn: "Pinterest requires 1 image/video/GIF to be added. If your post contains a link, we'll attempt to retrieve its preview image to use as the media.",
    tt: 'TikTok requires a video to be added.',
    igpn: "Instagram and Pinterest require media. Make sure to add at least 1 image/video for your Instagram post and 1 image/video/GIF for your Pinterest post. If your post contains a link, we'll attempt to retrieve its preview image to use as the media.",
    igtt: "Instagram and TikTok require media. Make sure to add at least 1 image/video for your Instagram post and 1 video for your TikTok post. If your post contains a link, we'll attempt to retrieve its preview image to use as the media for your Instagram post.",
    pntt: "TikTok and Pinterest require media. Make sure to add 1 video for your TikTok post and 1 image/video/GIF for your Pinterest post. If your post contains a link, we'll attempt to retrieve its preview image to use as the media for your Pinterest post.",
    igpntt:
      "Instagram, TikTok and Pinterest require media. Make sure to add at least 1 image/video for your Instagram post, 1 video for your TikTok post and 1 image/video/GIF for your Pinterest post. If your post contains a link, we'll attempt to retrieve its preview image to use as the media for your Instagram and Pinterest posts."
  },
  finishUpload: 'All media items should finish uploading before the post(s) can be saved.',
  noGifsAllowed: {
    ig: 'Instagram does not support GIFs.',
    gmb: 'Google Business Profile does not support GIFs.',
    tt: "We don't support GIFs for TikTok posts yet, please add a video instead.",
    gmbig: 'Instagram and Google Business Profile do not support GIFs.',
    igtt:
      '• Instagram does not support GIFs.\n' +
      "• We don't support GIFs for TikTok posts yet, please add a video instead.",
    gmbtt:
      '• Google Business Profile does not support GIFs.\n' +
      "• We don't support GIFs for TikTok posts yet, please add a video instead.",
    gmbigtt:
      '• Instagram and Google Business Profile do not support GIFs.\n' +
      "• We don't support GIFs for TikTok posts yet, please add a video instead."
  },
  noImagesAllowed: {
    tt: "We don't support images for TikTok posts yet, please add a video instead."
  },
  noMixedMedia: 'Media types (images/videos) cannot be mixed within a post',
  noVideosAllowed: {
    gmb: 'Google Business Profile does not support videos.'
  },
  pinterestBoardRequired: 'Select a Board for Pinterest profile(s)',
  pinterestCharLimit: 'Pinterest post cannot be longer than 500 characters',
  pinterestDuplicatesCheck:
    'The same Post Text/Variations cannot be published simultaneously to more than 3 Pinterest profiles.',
  pinterestLineBreakLimit: 'Pinterest post cannot have line breaks',
  pinterestMediaLimit: 'Pinterest post cannot contain more than 1 image/video/GIF.',
  preventAudioOnlyFiles: 'Audio files are not supported',
  preventPostNowForDisconnected: "'Post Now' cannot be selected for Disconnected Profile(s)",
  preventTwDuplicate:
    'The same Post Text/Variations cannot be published simultaneously to more than 1 X (Twitter) profile. Make sure to customize the text for each profile or set different posting times.',
  profileRequired: 'Select at least one Profile.',
  text: {
    required: 'Text is required',
    maxLength: 'Text exceeds limit.'
  },
  tikTokAudienceRequired: 'Select an Audience for TikTok profile(s)',
  tikTokMediaLimit: 'TikTok post cannot contain more than 1 video.',
  tikTokTextCharLimit: 'TikTok video caption cannot be longer than 2200 characters',
  tikTokVideoLength: 'TikTok videos cannot be shorter than 3 seconds or longer than 10 minutes',
  tikTokVideoSize: 'TikTok videos cannot be smaller than 360px (width/height)',
  titleCharLimit: 'Title cannot be longer than 100 characters',
  twitterMediaLimit: 'X (Twitter) post cannot contain more than 4 images or 1 video/GIF',
  twitterTextCharLimit: 'X (Twitter) post cannot be longer than 280 characters',
  videoNotTranscoded: 'All video files should finish transcoding before the post(s) can be published.'
};
